<ng-container *ngIf="airSearchForm && locatorItems?.length > 0 && airLocatorSearchForm && locatorFieldSpec">
    <h2 class="form-title">{{ wording.locator }}</h2>
    <form [formGroup]="airSearchForm">
        <combobox-field
                [items]="locatorItems"
                [fieldConfig]="locatorFieldSpec">
        </combobox-field>
    </form>
</ng-container>
